import { Entity, EntityLink } from '../entity';
import { ActivityEntityName } from '../shared/activity.entity.name';
import { defaultFinancialOptions } from './document.theme.financial.options';
import { defaultBillOptions, defaultInvoiceOptions } from './document.theme.invoice.options';
import { defaultPurchaseOrderOptions } from './document.theme.purchase.order.options';
import { defaultQuoteOptions } from './document.theme.quote.options';
import { PageOrientation, PageSize, ThemeTemplateMode } from './enums';

export interface DocumentTheme<T> extends Entity {
    entity: ActivityEntityName;
    isDefault: boolean;
    options: T;

    templateMode: ThemeTemplateMode;
    templateContent: any;
    templatePath: string;

    pageSize: PageSize;
    pageOrientation: PageOrientation;

    copyId?: string;
    inUse?: boolean;

    //scope
    companies?: Entity[];
    jobTypes?: Entity[];
    workCategories?: Entity[];
}

export type DocumentThemeAny = DocumentTheme<any>;

export const DocumentThemeEntities = [
    { _id: ActivityEntityName.Bill.toLowerCase(), name: 'Bills' } as Entity,
    { _id: ActivityEntityName.Invoice.toLowerCase(), name: 'Invoices' } as Entity,
    { _id: ActivityEntityName.Quote.toLowerCase(), name: 'Quotes' } as Entity,
    { _id: ActivityEntityName.SaleOrder.toLowerCase(), name: 'Sales Order' } as Entity,
    { _id: ActivityEntityName.PurchaseOrder.toLowerCase(), name: 'Purchase Order' } as Entity,
    { _id: ActivityEntityName.PrepaymentInvoice.toLowerCase(), name: 'Prepayment - Customer' } as Entity,
    { _id: ActivityEntityName.PrepaymentSupplier.toLowerCase(), name: 'Prepayment - Supplier' } as Entity,
    { _id: ActivityEntityName.CreditNote.toLowerCase(), name: 'Credit Note - Customer' } as Entity,
    { _id: ActivityEntityName.CreditNoteSupplier.toLowerCase(), name: 'Credit Note - Supplier' } as Entity,
    { _id: ActivityEntityName.WorkOrder.toLowerCase(), name: 'Stage' } as Entity,
    { _id: ActivityEntityName.WorkOrderDispatch.toLowerCase(), name: 'Stage Work Order' } as Entity,
    { _id: ActivityEntityName.Job.toLowerCase(), name: 'Job' } as Entity,
]

export const defaultDocumentTheme = {
    _id: null,
    active: true,
    templateMode: ThemeTemplateMode.Default,
    pageSize: PageSize.A4,
    pageOrientation: PageOrientation.Portrait
}

export const defaultDocumentThemes = {
    [ActivityEntityName.Quote.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.Quote,
        options: defaultQuoteOptions
    },
    [ActivityEntityName.Invoice.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.Invoice,
        options: defaultInvoiceOptions
    },
    [ActivityEntityName.Bill.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.Bill,
        options: defaultBillOptions
    },
    [ActivityEntityName.SaleOrder.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.SaleOrder,
        options: defaultFinancialOptions
    },
    [ActivityEntityName.Job.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.Job,
    },
    [ActivityEntityName.WorkOrder.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.WorkOrder,
    },
    [ActivityEntityName.WorkOrderDispatch.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.WorkOrderDispatch,
    },
    [ActivityEntityName.PurchaseOrder.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.PurchaseOrder,
        options: defaultPurchaseOrderOptions
    },
    [ActivityEntityName.PrepaymentInvoice.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.PrepaymentInvoice,
    },
    [ActivityEntityName.PrepaymentSupplier.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.PrepaymentSupplier,
    },
    [ActivityEntityName.CreditNote.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.CreditNote,
    },
    [ActivityEntityName.CreditNoteSupplier.toLocaleLowerCase()]: {
        ...defaultDocumentTheme,
        entity: ActivityEntityName.CreditNoteSupplier,
    }

}

export interface DocumentThemeScopeRequest {
    companyIds: string[];
    jobTypes: string[];
    workCategories: string[];
    entityLink?: EntityLink;
    entities: ActivityEntityName[];
    documentThemeTemplateMode?: ThemeTemplateMode;
}